<template>
  <div class="device-statuses">
    <span class="mr-2 subtitle-1" v-if="entity.hasOwnProperty('enabled')">
      {{ entity.enabled ? 'Enabled' : 'Disabled' }}
    </span>
    <span v-if="entity.schemaType === 'device'" style="display: inline-flex;">
      <battery-state class="mr-1" :object="entity" />
      <v-icon
        size="16px"
        class="mr-2"
        title="Response status"
        v-if="entity.deviceResponseStatus"
      >
        mdi-cloud-outline
      </v-icon>
      <v-icon
        size="16px"
        class="mr-2"
        title="Response status"
        v-else
        color="red"
      >
        mdi-cloud-off-outline
      </v-icon>
      <v-icon
        size="16px"
        class="mr-2"
        title="Emulation"
        v-if="entity.deviceEmulation"
      >
        mdi-blur
      </v-icon>
    </span>
    <v-icon size="16px" class="mr-2" v-if="entity.muted">
      mdi-volume-off
    </v-icon>
    <template v-if="entity.schemaType === 'media'">
      <span class="mr-2 subtitle-1">
        {{ entity.mediaType }}
      </span>
      <span class="mr-2 subtitle-1" v-if="entity.mediaSize">
        {{ entity.mediaSize }}
      </span>
    </template>
  </div>
</template>

<script>
import BatteryState from '@/components/device-states/BatteryState';
export default {
  name: 'ObjectStatuses',
  components: { BatteryState },
  props: {
    entity: {
      type: Object,
      required: true
    }
  }
};
</script>
